module.exports = __webpack_public_path__ + "static/media/fondobici.4f3ce7c3.png";